import { createSelector } from 'reselect';
import { isMessage } from 'helpers/intl-fns';

const bannerSelector = state => state.banner;

const selectBanner = createSelector(bannerSelector, banner => banner || {});

export const selectBannerInfo = createSelector(selectBanner, state => {
  const { type = 'info', message = null, values = {}, registeredBanners = [] } = state;
  return {
    type,
    targetId: registeredBanners[0],
    messageProps: isMessage(message) ? { ...message, values } : message,
  };
});
